import React from 'react'
import { motion } from 'framer-motion'
import { cn } from '../../lib/utils'

const CategoryTabs = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange, 
  className,
  ...props 
}) => {
  return (
    <div className={cn("flex overflow-x-auto gap-2 pb-2 scrollbar-hide", className)} {...props}>
      {categories.map((category, index) => (
        <motion.button
          key={category.id}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: index * 0.1 }}
          onClick={() => onCategoryChange(category.id)}
          className={cn(
            "relative px-6 py-3 rounded-full whitespace-nowrap transition-all duration-300 font-medium text-sm",
            selectedCategory === category.id
              ? "bg-primary-teal text-white shadow-medium"
              : "bg-white text-neutral-600 border border-neutral-300 hover:bg-neutral-50 hover:border-primary-teal/50"
          )}
        >
          {category.label}
          
          {/* Active indicator */}
          {selectedCategory === category.id && (
            <motion.div
              layoutId="activeTab"
              className="absolute inset-0 bg-primary-teal rounded-full -z-10"
              transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            />
          )}
        </motion.button>
      ))}
    </div>
  )
}

export default CategoryTabs
